import React from "react";

const OrientationToggleIcon = ({
  isHorizontal = false,
  className = "",
  ...props
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ cursor: "pointer", ...props.style }}
      {...props}
    >
      {isHorizontal ? (
        // Horizontal layout icon - two columns side by side
        <>
          <rect
            x="3"
            y="5"
            width="8"
            height="14"
            rx="1"
            stroke="white"
            strokeWidth="2"
          />
          <rect
            x="13"
            y="5"
            width="8"
            height="14"
            rx="1"
            stroke="white"
            strokeWidth="2"
          />
          <line
            x1="7"
            y1="8"
            x2="7"
            y2="16"
            stroke="white"
            strokeWidth="1.5"
            opacity="0.7"
          />
          <line
            x1="17"
            y1="8"
            x2="17"
            y2="16"
            stroke="white"
            strokeWidth="1.5"
            opacity="0.7"
          />
        </>
      ) : (
        // Vertical layout icon - stacked panels
        <>
          <rect
            x="4"
            y="3"
            width="16"
            height="7"
            rx="1"
            stroke="white"
            strokeWidth="2"
          />
          <rect
            x="4"
            y="14"
            width="16"
            height="7"
            rx="1"
            stroke="white"
            strokeWidth="2"
          />
          <line
            x1="7"
            y1="6.5"
            x2="17"
            y2="6.5"
            stroke="white"
            strokeWidth="1.5"
            opacity="0.7"
          />
          <line
            x1="7"
            y1="17.5"
            x2="17"
            y2="17.5"
            stroke="white"
            strokeWidth="1.5"
            opacity="0.7"
          />
        </>
      )}
    </svg>
  );
};

export default OrientationToggleIcon;
